import React, { Component } from "react";
import {
  Card,
  CardBody,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  Input,
  ButtonGroup,
  Row,
  Col,
  Button,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
  Badge,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";
import {
  getReqestRowDetails,
  getDetMeterialReqList,
  toggleItemMenu,
  modelListOpen,
  modelListClose,
  SetParams,
  listlayout,
  viewLogShowRightSidebar,
  getPDFDownload,
} from "../../../store/MaterialRequest/actions";
import moment from "moment";
import { AvForm } from "availity-reactstrap-validation";
import Defaultuser from "../../../assets/images/users/Default_User.png";
import LoadingModel from "../../LoadingModel";

class AllMaterial extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
    };
  }

  componentDidMount() {
    this.props.SetParams(this.props.params);
  }

  onSortChange = () => {
    var sort = ["id", "createdon"];
    var currentSort = this.props.params.currentSort;
    var i = sort.indexOf(currentSort);
    if (i !== -1 && i + 1 < sort.length) {
      currentSort = sort[i + 1];
    } else {
      currentSort = sort[0];
    }
    this.props.SetParams({ ...this.props.params, currentSort: currentSort });
    this.props.getDetMeterialReqList({
      ...this.props.params,
      currentSort: currentSort,
    });
  };
  onSortOrderChange = () => {
    var sortOrder = this.props.params.sortOrder;
    if (sortOrder === "-") {
      sortOrder = "";
    } else {
      sortOrder = "-";
    }

    this.props.SetParams({ ...this.props.params, sortOrder: sortOrder });
    this.props.getDetMeterialReqList({
      ...this.props.params,
      sortOrder: sortOrder,
    });
  };
  onlayoutChange = () => {
    var layout = this.props.layout;
    if (layout === "list") {
      layout = "table";
    } else {
      layout = "list";
    }
    this.props.listlayout(layout);
  };
  autohandleSearch = (e) => {
    this.props.SetParams({
      ...this.props.params,
      search: e.target.value,
      page: 1,
    });
    if (e.target.value === "") {
      this.props.getDetMeterialReqList(
        {
          ...this.props.params,
          search: "",
          page: 1,
        },
        true
      );
    }
  };
  handleSearch = (e) => {
    if (e.key === "Enter") {
      this.props.getDetMeterialReqList({
        ...this.props.params,
        page: 1,
        search: e.target.value,
      });
    }
  };

  openPage(pageNo) {
    this.props.SetParams({ ...this.props.params, page: pageNo });
    this.props.getDetMeterialReqList({ ...this.props.params, page: pageNo });
  }
  getPDF(id) {
    this.props.getPDFDownload(id);
  }
  viewLog(id) {
    this.props.viewLogShowRightSidebar(id);
  }

  render() {
    return (
      <React.Fragment>
        {this.props.loading && <LoadingModel OpenModel={this.props.loading} />}

        <div className="mt-2 ">
          <div>
            <Row>
              <Col md={3}>
                <div className=" p-1">
                  <AvForm className="p-1">
                    <FormGroup className="m-0">
                      <InputGroup>
                        <Input
                          type="text"
                          name="search"
                          className="form-control d-inline-block"
                          placeholder="Search"
                          validate={{ required: true }}
                          onChange={(e) => this.autohandleSearch(e)}
                          onKeyDown={(e) => this.handleSearch(e)}
                        />
                        <InputGroupAddon addonType="append">
                          <Button
                            color="light"
                            type="submit"
                            onClick={() =>
                              this.props.getDetMeterialReqList({
                                ...this.props.params,
                                page: 1,
                              })
                            }
                          >
                            <i className="ri-search-line"></i>
                          </Button>
                        </InputGroupAddon>
                      </InputGroup>
                    </FormGroup>
                  </AvForm>
                </div>
              </Col>
              <Col md={9}>
                <div className="float-right p-1">
                  <div className="d-inline-block">
                    <Pagination aria-label="Page navigation example">
                      <PaginationItem disabled={this.props.params.page <= 1}>
                        <PaginationLink
                          onClick={(e) => this.openPage(1)}
                          previous
                          // href="#"
                        />
                      </PaginationItem>

                      {this.props.params.page > 2 && (
                        <PaginationItem disabled={this.props.params.page <= 2}>
                          <PaginationLink
                            onClick={() =>
                              this.openPage(this.props.params.page - 2)
                            }
                            // href="#"
                          >
                            {this.props.params.page - 2}
                          </PaginationLink>
                        </PaginationItem>
                      )}
                      {this.props.params.page > 1 && (
                        <PaginationItem disabled={this.props.params.page === 1}>
                          <PaginationLink
                            onClick={() =>
                              this.openPage(this.props.params.page - 1)
                            }
                            // href="#"
                          >
                            {this.props.params.page - 1}
                          </PaginationLink>
                        </PaginationItem>
                      )}

                      <PaginationItem active={true}>
                        <PaginationLink
                          onClick={() => this.openPage(this.props.params.page)}
                          // href="#"
                        >
                          {this.props.params.page}
                        </PaginationLink>
                      </PaginationItem>
                      {this.props.params.page + 1 <=
                        this.props.params.no_of_pages && (
                        <PaginationItem
                          disabled={
                            this.props.params.page + 1 >
                            this.props.params.no_of_pages
                          }
                        >
                          <PaginationLink
                            onClick={() =>
                              this.openPage(this.props.params.page + 1)
                            }
                            // href="#"
                          >
                            {this.props.params.page + 1}
                          </PaginationLink>
                        </PaginationItem>
                      )}
                      {this.props.params.page + 2 <=
                        this.props.params.no_of_pages && (
                        <PaginationItem
                          disabled={
                            this.props.params.page + 2 >
                            this.props.params.no_of_pages
                          }
                        >
                          <PaginationLink
                            onClick={() =>
                              this.openPage(this.props.params.page + 2)
                            }
                            // href="#"
                          >
                            {this.props.params.page + 2}
                          </PaginationLink>
                        </PaginationItem>
                      )}
                      {this.props.params.page + 3 <=
                        this.props.params.no_of_pages &&
                        this.props.params.page < 3 && (
                          <PaginationItem
                            disabled={
                              this.props.params.page + 3 >
                              this.props.params.no_of_pages
                            }
                          >
                            <PaginationLink
                              onClick={() =>
                                this.openPage(this.props.params.page + 3)
                              }
                              // href="#"
                            >
                              {this.props.params.page + 3}
                            </PaginationLink>
                          </PaginationItem>
                        )}
                      {this.props.params.page + 4 <=
                        this.props.params.no_of_pages &&
                        this.props.params.page < 2 && (
                          <PaginationItem
                            disabled={
                              this.props.params.page + 4 >
                              this.props.params.no_of_pages
                            }
                          >
                            <PaginationLink
                              onClick={() =>
                                this.openPage(this.props.params.page + 4)
                              }
                              // href="#"
                            >
                              {this.props.params.page + 4}
                            </PaginationLink>
                          </PaginationItem>
                        )}

                      <PaginationItem
                        disabled={
                          this.props.params.no_of_pages ===
                          this.props.params.page
                        }
                      >
                        <PaginationLink
                          onClick={(e) =>
                            this.openPage(this.props.params.no_of_pages)
                          }
                          next
                          // href="#"
                        />
                      </PaginationItem>
                    </Pagination>
                  </div>
                  <ButtonGroup className="waves-effect waves-light d-inline-block ml-2 mr-2">
                    <Button color="light" onClick={this.onSortOrderChange}>
                      {this.props.params.sortOrder === "-" && (
                        <i className="mdi mdi-sort-ascending mr-1"></i>
                      )}
                      {this.props.params.sortOrder === "" && (
                        <i className="mdi mdi-sort-descending mr-1"></i>
                      )}
                    </Button>
                    <Button color="light" onClick={this.onSortChange}>
                      {this.props.Sortvar[this.props.params.currentSort]}
                    </Button>
                  </ButtonGroup>
                  <Button color="light" onClick={this.onlayoutChange}>
                    {this.props.layout === "list" && (
                      <i className="mdi mdi-table-large"></i>
                    )}
                    {this.props.layout === "table" && (
                      <i className="mdi mdi-format-list-bulleted"></i>
                    )}
                  </Button>
                </div>
              </Col>
            </Row>
          </div>

          <SimpleBar style={{ maxHeight: "100%" }}>
            <Card className="p-0">
              {this.props.layout === "table" && (
                <CardBody className="p-2 ">
                  <div className="table-responsive m-0">
                    <Table bordered hover className="mb-0 p-0 table-centered">
                      <thead className="bg-light text-center">
                        <tr>
                          <th className="nowrap">MR Code</th>
                          <th className="nowrap">No.of Items</th>
                          <th className="nowrap">Location</th>
                          <th className="nowrap">Sub Location</th>
                          <th className="nowrap">User Department</th>
                          <th className="nowrap">Due Date</th>

                          <th className="nowrap">Submited</th>
                          <th className="nowrap">MR Status</th>
                          <th className="nowrap">PI Status</th>
                          <th className="nowrap">MI Status</th>
                          <th className="nowrap">Action</th>
                        </tr>
                      </thead>
                      <tbody className="nowrap">
                        {this.props.mrRowlistcount !== 0 ? (
                          <>
                            {this.props.mrRowList?.map((Material, key) => (
                              <tr key={key} className="text-center">
                                <td>
                                  <Link to={`materialrequest2/${Material.id}`}>
                                    <Button
                                      type="button"
                                      color={
                                        this.props.activeTab === 5 ||
                                        this.props.activeTab === 6
                                          ? Material.pistatus === 1 ||
                                            Material.pistatus === 2
                                            ? "pink"
                                            : "dark"
                                          : this.props.activeTab === 7 ||
                                            this.props.activeTab === 8
                                          ? Material.mistatus === 1 ||
                                            Material.mistatus === 2 ||
                                            Material.mistatus === 3
                                            ? "dark"
                                            : "secondary"
                                          : Material.mrstatus === 1 ||
                                            Material.mrstatus === 2
                                          ? "primary"
                                          : Material.mrstatus === 3 ||
                                            Material.mrstatus === 5
                                          ? "success"
                                          : Material.mrstatus === 9 ||
                                            Material.mrstatus === 10 ||
                                            Material.mrstatus === 11 ||
                                            Material.mrstatus === 12
                                          ? "info"
                                          : "danger"
                                      }
                                      className="waves-effect waves-light orderlist_but p-1"
                                      // href={`materialrequest2/${Material.id}`}
                                    >
                                      <i className="mdi mdi-file-document mr-1"></i>
                                      {Material.code}
                                    </Button>
                                  </Link>
                                </td>
                                <td>
                                  <Link
                                    to="#"
                                    className="m-0"
                                    onClick={() =>
                                      this.props.modelListOpen(Material.id)
                                    }
                                  >
                                    {Material.items_count} Items
                                  </Link>
                                </td>
                                <td> {Material?.location?.name}</td>
                                <td> {Material?.sublocation?.name}</td>
                                <td> {Material?.userdepartment?.name}</td>
                                <td>
                                  {moment(Material.date).format("DD-MM-YYYY")}
                                </td>

                                <td>
                                  {moment(Material.createdon).format(
                                    "DD-MM-YYYY"
                                  )}
                                </td>
                                <td>
                                  <Badge
                                    className="font-size-14"
                                    color={
                                      Material.mrstatus === 1 ||
                                      Material.mrstatus === 2
                                        ? "primary"
                                        : Material.mrstatus === 3 ||
                                          Material.mrstatus === 5
                                        ? "success"
                                        : Material.mrstatus === 9 ||
                                          Material.mrstatus === 10 ||
                                          Material.mrstatus === 11 ||
                                          Material.mrstatus === 12
                                        ? "info"
                                        : "danger"
                                    }
                                  >
                                    {Material.mrstatus_name}
                                  </Badge>
                                </td>
                                <td>
                                  <Badge
                                    className="font-size-14"
                                    color={
                                      Material.pistatus === 1 ||
                                      Material.pistatus === 2
                                        ? "pink"
                                        : "dark"
                                    }
                                  >
                                    {Material.pistatus_name}
                                  </Badge>
                                </td>
                                <td>
                                  <Badge
                                    className="font-size-14"
                                    color={
                                      Material.mistatus === 1 ||
                                      Material.mistatus === 2 ||
                                      Material.mistatus === 3
                                        ? "dark"
                                        : "secondary"
                                    }
                                  >
                                    {Material.mistatus_name}
                                  </Badge>
                                </td>
                                <td>
                                  {/* <Button
                                    outline
                                    size="sm"
                                    type="button"
                                    color="secondary"
                                    className="waves-effect waves-light mr-2"
                                    onClick={() => this.getPDF(Material.id)}
                                  >
                                    <i className="mdi mdi-file-pdf"></i>
                                  </Button> */}
                                  <Button
                                    outline
                                    size="sm"
                                    type="button"
                                    color="info"
                                    className="waves-effect waves-light mr-2"
                                    onClick={() => this.viewLog(Material.id)}
                                  >
                                    <i className="mdi mdi-eye"></i>
                                  </Button>
                                </td>
                              </tr>
                            ))}
                          </>
                        ) : (
                          <tr>
                            <td colspan="7" className="text-center">
                              <span className="font-size-18 text-danger">
                                Data not available
                              </span>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                    {/* </TableScrollbar> */}
                  </div>
                </CardBody>
              )}
              {this.props.layout === "list" && (
                <CardBody className="p-2 ">
                  {this.props.mrRowlistcount !== 0 ? (
                    <>
                      {this.props.mrRowList?.map((Material) => (
                        <div className="bg_color p-2 mb-1" key={Material.id}>
                          <div className="float-right ml-3">
                            {/* <Button
                              outline
                              size="sm"
                              type="button"
                              color="primary"
                              className="waves-effect waves-light d-inline-block mr-2"
                              // style={
                              //   Material.mrstatus == 1
                              //     ? {
                              //         display: "block",
                              //       }
                              //     : {
                              //         display: "none",
                              //       }
                              // }
                              disabled={Material.mrstatus == 1 ? false : true}
                              // href={`NewMaterialRequest/${Material.id}`}
                            >
                              <i className="mdi mdi-backup-restore icon-large "></i>
                            </Button> */}
                            <Dropdown
                              isOpen={Material.actionMenu}
                              toggle={() =>
                                this.props.toggleItemMenu(Material.id)
                              }
                              className="d-inline-block"
                            >
                              <DropdownToggle caret color="light" size="sm">
                                <i className="ri-more-line "></i>
                              </DropdownToggle>
                              <DropdownMenu right>
                                {/* <DropdownItem
                                  href="#"
                                  onClick={() => this.getPDF(Material.id)}
                                >
                                  PDF Download
                                </DropdownItem> */}
                                {!this.state.isMobile && (
                                  <DropdownItem
                                    onClick={() => this.viewLog(Material.id)}
                                  >
                                    View log
                                  </DropdownItem>
                                )}
                              </DropdownMenu>
                            </Dropdown>{" "}
                          </div>
                          <Row className="justify-content-center">
                            <Col xs={12} sm={12} md={3} lg={3} xl={2}>
                              <div className="detiles p-2">
                                <Link to={`materialrequest2/${Material.id}`}>
                                  <Button
                                    type="button"
                                    block
                                    color={
                                      this.props.activeTab === 5 ||
                                      this.props.activeTab === 6
                                        ? Material.pistatus === 1 ||
                                          Material.pistatus === 2
                                          ? "pink"
                                          : "dark"
                                        : this.props.activeTab === 7 ||
                                          this.props.activeTab === 8
                                        ? Material.mistatus === 1 ||
                                          Material.mistatus === 2 ||
                                          Material.mistatus === 3
                                          ? "dark"
                                          : "secondary"
                                        : Material.mrstatus === 1 ||
                                          Material.mrstatus === 2
                                        ? "primary"
                                        : Material.mrstatus === 3 ||
                                          Material.mrstatus === 5
                                        ? "success"
                                        : Material.mrstatus === 9 ||
                                          Material.mrstatus === 10 ||
                                          Material.mrstatus === 11 ||
                                          Material.mrstatus === 12
                                        ? "info"
                                        : "danger"
                                    }
                                    className="waves-effect waves-light p-1 mb-2"
                                  >
                                    <i className="mdi mdi-file-document mr-1"></i>
                                    {Material.code}
                                  </Button>
                                </Link>
                                <p className="items_title m-1">
                                  List Items:{" "}
                                  <span className="item_title_Detiles">
                                    {Material.items_count}
                                  </span>
                                </p>
                                <Link
                                  to="#"
                                  className="m-0"
                                  onClick={() =>
                                    this.props.modelListOpen(Material.id)
                                  }
                                >
                                  <i className="mdi mdi-plus"></i>
                                  More Details
                                </Link>
                              </div>
                            </Col>
                            <Col xs={12} sm={12} md={9} lg={9} xl={10}>
                              <div className="Material_body">
                                <p className="mb-1 body_title">
                                  {Material.description}
                                </p>
                              </div>
                              <hr className="my-0" />
                              <Row className="p-0">
                                <Col
                                  xs={12}
                                  sm={12}
                                  md={8}
                                  lg={8}
                                  xl={8}
                                  className="p-0"
                                >
                                  <div className="panel-content">
                                    <div className="list-column row">
                                      <div className="list-data col-xl-6">
                                        <span className="ttl">Due Date:</span>

                                        <span className="dtl">
                                          {moment(Material.date).format(
                                            "DD-MM-YYYY"
                                          )}
                                        </span>
                                      </div>
                                      {/* <div className="list-data col-xl-6">
                                        <span className="ttl">Department:</span>

                                        <span className="dtl">
                                          {Material.department?.name}
                                        </span>
                                      </div> */}
                                      <div className="list-data col-xl-6">
                                        <span className="ttl">Submited:</span>

                                        <span className="dtl">
                                          {moment(Material.createdon).format(
                                            "DD-MM-YYYY"
                                          )}
                                        </span>
                                      </div>
                                      <div className="list-data col-xl-6">
                                        <span className="ttl">Location:</span>

                                        <span className="dtl">
                                          {Material?.location?.name}
                                        </span>
                                      </div>
                                      <div className="list-data col-xl-6">
                                        <span className="ttl">
                                          Sub Location:
                                        </span>

                                        <span className="dtl">
                                          {Material?.sublocation?.name}
                                        </span>
                                      </div>

                                      <div className="list-data col-xl-6">
                                        <span className="ttl">Status:</span>

                                        <span className="dtl">
                                          {Material.mrstatus_name}
                                        </span>
                                      </div>
                                      <div className="list-data col-xl-6">
                                        <span className="ttl">
                                          User Department:
                                        </span>
                                        <span className="dtl">
                                          {Material.userdepartment.name}
                                        </span>
                                      </div>
                                      {Material.mrstatus !== 6 &&
                                        Material.mrstatus !== 4 && (
                                          <>
                                            <div className="list-data col-xl-6">
                                              <span className="ttl">
                                                PI Status:
                                              </span>

                                              <span className="dtl">
                                                {Material.pistatus_name}
                                              </span>
                                            </div>
                                            <div className="list-data col-xl-6">
                                              <span className="ttl">
                                                MR Issue Status:
                                              </span>

                                              <span className="dtl">
                                                {Material.mistatus_name}
                                              </span>
                                            </div>
                                          </>
                                        )}
                                    </div>
                                  </div>
                                </Col>
                                <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                                  <div className="float-right">
                                    <div className="status-content-box">
                                      <span className="ttl">Create by</span>
                                    </div>
                                    <div className="user-column">
                                      <div className="img">
                                        <img
                                          className="img-fluid p-0"
                                          src={
                                            Material.createdby?.image == null
                                              ? Defaultuser
                                              : Material.createdby?.image
                                          }
                                          alt="user"
                                        />
                                      </div>

                                      <p className="ttl">
                                        <b>{Material.createdby?.fullname}</b>
                                      </p>
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </div>
                      ))}
                    </>
                  ) : (
                    <div className="text-center">
                      <span className="font-size-24 text-danger">
                        Data not available{" "}
                      </span>
                    </div>
                  )}
                </CardBody>
              )}
            </Card>
          </SimpleBar>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { mrRowList, mrRowlistcount, params, Sortvar, layout, loading } =
    state.Materialrequest;
  return { mrRowList, mrRowlistcount, params, Sortvar, layout, loading };
};

export default connect(mapStatetoProps, {
  getReqestRowDetails,
  getDetMeterialReqList,
  SetParams,
  listlayout,
  toggleItemMenu,
  modelListOpen,
  modelListClose,
  getPDFDownload,
  viewLogShowRightSidebar,
})(AllMaterial);
